/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ContractNoticeDetailsResponse } from './contractNoticeDetailsResponse';
import { ManagementBusinessEntityResponse } from './managementBusinessEntityResponse';
import { ManagementMediumResponse } from './managementMediumResponse';
import { ManagementTagResponse } from './managementTagResponse';

export interface ManagementContractNoticeResponse { 
    id: string;
    number?: string;
    procurementType?: ManagementContractNoticeResponse.ProcurementTypeEnum;
    description?: string;
    estimatedPurchaseValue?: number;
    currency?: ManagementContractNoticeResponse.CurrencyEnum;
    procedureType?: string;
    divisiblePurchase?: boolean;
    deliveryDate?: Date;
    publishedDate?: Date;
    url?: string;
    fileUrl?: string;
    status?: string;
    type?: ManagementContractNoticeResponse.TypeEnum;
    country?: ManagementContractNoticeResponse.CountryEnum;
    createdFromAnnouncement?: boolean;
    autoTaggedMultipleCriteria?: boolean;
    autoTaggedSingleCriteria?: boolean;
    aiAutoTagged?: boolean;
    contractAuthority?: ManagementBusinessEntityResponse;
    contractors?: Array<ManagementBusinessEntityResponse>;
    mediums?: Array<ManagementMediumResponse>;
    tags?: Array<ManagementTagResponse>;
    details?: Array<ContractNoticeDetailsResponse>;
    other?: { [key: string]: any; };
    eauction?: boolean;
    /** Hand-added (autotag UI, no live /api-docs yet). 1-4, null = manual/no signal. */
    color?: number;
    /** Hand-added (autotag UI, no live /api-docs yet). 0-1, higher = riskier, null = no signal. */
    riskScore?: number;
    /** Hand-added (autotag UI, no live /api-docs yet). */
    reviewed?: boolean;
}
export namespace ManagementContractNoticeResponse {
    export type ProcurementTypeEnum = 'GOODS' | 'SERVICES' | 'WORKS' | 'OTHER';
    export const ProcurementTypeEnum = {
        GOODS: 'GOODS' as ProcurementTypeEnum,
        SERVICES: 'SERVICES' as ProcurementTypeEnum,
        WORKS: 'WORKS' as ProcurementTypeEnum,
        OTHER: 'OTHER' as ProcurementTypeEnum
    };
    export type CurrencyEnum = 'MKD' | 'EUR' | 'USD' | 'ALL';
    export const CurrencyEnum = {
        MKD: 'MKD' as CurrencyEnum,
        EUR: 'EUR' as CurrencyEnum,
        USD: 'USD' as CurrencyEnum,
        ALL: 'ALL' as CurrencyEnum
    };
    export type TypeEnum = 'CONTRACT_NOTICE' | 'E_MARKET' | 'CONCESSION' | 'DEFENSE_AND_SECURITY_LAW' | 'SPECIAL_SERVICES' | 'TECHNICAL_DIALOGUES';
    export const TypeEnum = {
        CONTRACTNOTICE: 'CONTRACT_NOTICE' as TypeEnum,
        EMARKET: 'E_MARKET' as TypeEnum,
        CONCESSION: 'CONCESSION' as TypeEnum,
        DEFENSEANDSECURITYLAW: 'DEFENSE_AND_SECURITY_LAW' as TypeEnum,
        SPECIALSERVICES: 'SPECIAL_SERVICES' as TypeEnum,
        TECHNICALDIALOGUES: 'TECHNICAL_DIALOGUES' as TypeEnum
    };
    export type CountryEnum = 'MK' | 'AL' | 'XK';
    export const CountryEnum = {
        MK: 'MK' as CountryEnum,
        AL: 'AL' as CountryEnum,
        XK: 'XK' as CountryEnum
    };
}